export default __webpack_public_path__ + "c18edc6e9d78bff28518478cba58f1a7.png";